const timelineInit = () => {
    if (typeof Swiper === "function") {
        const timeline = document.querySelectorAll(".gg-block-timeline");
        const body = document.querySelector("body");

        timeline.forEach((module) => {
            const onlyCarousel = module.classList.contains("gg-block-timeline--only-carousel");

            // eslint-disable-next-line no-undef
            const swiperTimeline = new Swiper(module.querySelector(".gg-block-timeline__swiper-timeline"), {
                slidesPerView: 1,
                direction: "horizontal",
                centeredSlides: true,
                spaceBetween: 30,
                activeIndex: 1,
                mousewheelControl: false,
                slideToClickedSlide: true,
                navigation: {
                    nextEl: onlyCarousel ? module.querySelector(".swiper-button-next") : false,
                    prevEl: onlyCarousel ? module.querySelector(".swiper-button-prev") : false,
                },
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                    },
                    767: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    1365: {
                        slidesPerView: 5,
                    },
                    1600: {
                        slidesPerView: 6,
                    },
                },
            });

            if (!onlyCarousel) {
                // eslint-disable-next-line no-undef
                const swiperImage = new Swiper(module.querySelector(".gg-block-timeline__swiper-image"), {
                    slidesPerView: 1,
                    direction: "horizontal",
                    navigation: {
                        nextEl: module.querySelector(".swiper-button-next"),
                        prevEl: module.querySelector(".swiper-button-prev"),
                    },
                    on: {
                        slideChange(e) {
                            swiperTimeline.slideTo(e.activeIndex);
                        },
                    },
                });

                // eslint-disable-next-line no-undef
                const swiperTextContent = new Swiper(module.querySelector(".gg-block-timeline__swiper-text-content"), {
                    slidesPerView: 1,
                    direction: "horizontal",
                    autoHeight: !body.classList.contains("block-editor-page"), // disable for editor
                    on: {
                        slideChange(e) {
                            swiperTimeline.slideTo(e.activeIndex);
                            swiperImage.slideTo(e.activeIndex);
                        },
                    },
                });

                swiperTimeline.on("slideChange", (e) => {
                    swiperTextContent.slideTo(e.activeIndex);
                    swiperImage.slideTo(e.activeIndex);
                });
            }
        });
    }
};

timelineInit();

if (window.acf) {
    window.acf.addAction("render_block_preview/type=timeline", timelineInit);
}
